import { gql } from '@apollo/client/core';

export const updateBillingAccount = gql`
  mutation updateBillingAccount($data: BillingAccountUpdateInput!, $where: BillingAccountWhereUniqueInput!) {
    updateBillingAccount(data: $data, where: $where) {
      id
      name
      cif
      city
      zipCode
      countryCode
      fiscalAddress
      Partner {
        id
        name
        orgCode
      }
    }
  }
`;
